<template>
    <vx-box color="info" class="mt-20 flex flex-col items-center justify-center gap-8 py-16">
        <motion.div
            :initial="checkmarkVariants.hidden"
            :animate="checkmarkVariants.visible"
            :transition="checkmarkTransition"
            class="-mt-26 shadow-md border-l border-b border-x border-white flex items-center justify-center size-20 rounded-full bg-violet-100 text-violet-600"
        >
            <font-awesome-icon widthAuto size="2x" :icon="faSparkles"></font-awesome-icon>
        </motion.div>

        <motion.div initial="hidden" animate="visible" :transition="successTextStagger" class="text-center space-y-2">
            <motion.h2
                :variants="fadeUpVariants"
                :transition="mediumTransition"
                class="text-2xl font-bold text-slate-800"
            >
                AI-Prioritized Inbox for Franchise Brands
            </motion.h2>
            <motion.p :variants="fadeUpVariants" :transition="mediumTransition" class="text-slate-500 text-lg max-w-md">
                Let AI classify and prioritize every inbound message, so your team spends less time sorting and more
                time closing.
            </motion.p>
        </motion.div>

        <motion.div
            :initial="fadeUpVariants.hidden"
            :animate="fadeUpVariants.visible"
            :transition="heroLineTransition"
            class="w-16 border-t border-slate-200"
        ></motion.div>

        <div class="text-center space-y-4">
            <motion.p
                :initial="fadeUpVariants.hidden"
                :animate="fadeUpVariants.visible"
                :transition="heroSubtitleTransition"
                class="text-sm font-semibold uppercase tracking-wider text-slate-500"
            >
                Focus on what drives value
            </motion.p>

            <motion.div
                initial="hidden"
                animate="visible"
                :transition="successPillStagger"
                class="flex items-center gap-3"
            >
                <motion.span :variants="successPillVariants" :transition="successPillTransition">
                    <meta-badge shadow class="py-1.5 px-2.5" color="sky">
                        <font-awesome-icon widthAuto :icon="faBolt" class="text-sky-500"></font-awesome-icon>
                        Respond faster
                    </meta-badge>
                </motion.span>
                <motion.span :variants="successPillVariants" :transition="successPillTransition">
                    <meta-badge shadow class="py-1.5 px-2.5" color="emerald">
                        <font-awesome-icon
                            widthAuto
                            :icon="faArrowTrendUp"
                            class="text-emerald-500"
                        ></font-awesome-icon>
                        Convert More
                    </meta-badge>
                </motion.span>
                <motion.span :variants="successPillVariants" :transition="successPillTransition">
                    <meta-badge shadow class="py-1.5 px-2.5" color="amber">
                        <font-awesome-icon widthAuto :icon="faShieldCheck" class="text-amber-500"></font-awesome-icon>
                        Miss nothing
                    </meta-badge>
                </motion.span>
            </motion.div>
        </div>

        <motion.div
            :initial="fadeUpVariants.hidden"
            :animate="fadeUpVariants.visible"
            :transition="heroButtonTransition"
            class="pt-4"
        >
            <div class="flex flex-col justify-center gap-4 items-center">
                <vx-button color="info" size="xl" fancy @click="emit('start')">
                    Get Started
                    <font-awesome-icon :icon="faArrowRight"></font-awesome-icon>
                </vx-button>
                <router-link class="text-sm font-semibold text-slate-500" :to="{ name: 'message-hub' }">
                    Not now
                </router-link>
            </div>
        </motion.div>
    </vx-box>
</template>

<script lang="ts" setup>
import { RouterLink } from 'vue-router';
import { VxBox, VxButton } from '@voxie/frontend-components';
import { faSparkles, faBolt, faArrowTrendUp, faShieldCheck, faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { motion } from 'motion-v';
import {
    fadeUpVariants,
    checkmarkVariants,
    checkmarkTransition,
    mediumTransition,
    successTextStagger,
    successPillVariants,
    successPillStagger,
    successPillTransition,
    heroLineTransition,
    heroSubtitleTransition,
    heroButtonTransition,
} from './wizardMotionVariants';
import MetaBadge from '~/components/general/MetaBadge.vue';

const emit = defineEmits<{
    start: [];
}>();
</script>
